import __vue_component__ from '../Button/Button.vue.js';
import EditorBoldIcon from '../Icon/EditorBoldIcon.js';
import EditorBulletListIcon from '../Icon/EditorBulletListIcon.js';
import EditorCodeIcon from '../Icon/EditorCodeIcon.js';
import EditorItalicIcon from '../Icon/EditorItalicIcon.js';
import EditorNumberListIcon from '../Icon/EditorNumberListIcon.js';
import EditorQuoteIcon from '../Icon/EditorQuoteIcon.js';
import EditorStrikethroughIcon from '../Icon/EditorStrikethroughIcon.js';
import EditorUnderlineIcon from '../Icon/EditorUnderlineIcon.js';
import { EditorContent, EditorMenuBar, Editor } from '../../node_modules/tiptap/dist/tiptap.esm.js';
import Image from './custom-extensions/nodes/Image.js';
import Doc from './custom-extensions/nodes/Doc.js';
import Placeholder from './custom-extensions/nodes/Placeholder.js';
import { extensions } from './extensions.js';

//
var script = {
  components: {
    EditorContent,
    EditorMenuBar,
    EditorBoldIcon,
    EditorItalicIcon,
    EditorUnderlineIcon,
    EditorBulletListIcon,
    EditorNumberListIcon,
    EditorQuoteIcon,
    EditorCodeIcon,
    EditorStrikethroughIcon,
    Button: __vue_component__
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Object],
      default: ''
    },
    menu: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Write something...'
    },
    onFocus: {
      type: Function,
      default: () => ({})
    },
    emptyFieldText: {
      type: String,
      default: 'Click to add description...'
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      updated: false,
      editor: new Editor({
        editable: this.editable,
        extensions: [new Doc(), new Image({
          baseUrl: this.baseUrl
        }), ...extensions, new Placeholder({
          emptyNodeText: this.placeholder
        })],
        onFocus: this.onFocus,
        content: this.value,
        onUpdate: ({
          getJSON
        }) => {
          this.updated = true;
          const json = getJSON();
          const {
            content
          } = json;

          if (Array.isArray(content) && content.length === 1 && !Object.prototype.hasOwnProperty.call(content[0], 'content')) {
            this.$emit('input', null);
          } else {
            const doc = JSON.parse(JSON.stringify(json, (k, v) => v != null ? v : undefined));
            this.$emit('input', { ...doc,
              version: 1
            });
          }
        }
      })
    };
  },

  watch: {
    editable(editable) {
      this.editor.setOptions({
        editable
      });
    },

    value: {
      handler(value) {
        if (this.updated) {
          this.updated = false;
          return;
        }

        if (this.editor) {
          try {
            this.editor.setContent(value);
          } catch (e) {
            this.editor.setContent(e.message);
          }
        }
      },

      immediate: true
    }
  },

  beforeDestroy() {
    this.editor.destroy();
  },

  methods: {
    onEditRequested() {
      if (!this.editable) {
        this.$emit('edit-requested');
      }
    },

    insertDocument(json) {
      const {
        selection: {
          from,
          to
        },
        doc
      } = this.editor.state;

      if (!doc.textContent) {
        this.editor.setContent(json);
      } else {
        const node = this.editor.schema.nodeFromJSON(json);
        const transaction = this.editor.state.tr.replaceRangeWith(from, to, node);
        this.editor.view.dispatch(transaction);
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/RichTextEditor.vue_rollup-plugin-vue=script.js